import { api, financeAPI } from "../../axios";

export const actions = {

    //PrePlanningTarget
    GetPrePlanningTargets(context, data){
        return api.get(`PrePlanningTarget/PrePlanning/${data.campusId}/${data.cycle}`);
    },
    GetPrePlanningByDU(context, data){
        return api.get(`PrePlanningTarget/DeliveryUnit/${data.id}/${data.cycle}`);
    },
    PostPrePlanningTarget(context, data){
        return api.post(`PrePlanningTarget/Post/${data}`);
    },
    GetMyPrePlanning(context, data){
        return api.get(`PrePlanningTarget/My/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetMyFundsPrePlanning(context, data){
        return api.get(`PrePlanningTarget/My/Funds/${data.cycle}/${data.deliveryUnitId}`);
    },
    GetPrePlanningDUs(context, data){
        return api.get(`PrePlanningTarget/DeliveryUnits/${data.cycle}/${data.campusId}`);
    },
    CreatePreplanning(context, data){
        return api.post(`PrePlanningTarget/Add/${data.saveAndPost}`, data);
    },
    TransferFund(context, data){
        return financeAPI.put(`FinanceTemplateBudgetItem/Transfer/Amount`, data);
    },
    AddFund(context, data){
        return financeAPI.post(`FinanceTemplateObjectOfExpenditure/Manual/Add/${data.deliveryUnitId}/${data.financeTemplateId}`, data.accountIds);
    },
    AvailableAccounts(context, data){
        return financeAPI.get(`FinanceTemplateObjectOfExpenditure/AvailableAccounts/DeliveryUnit/${data}`);
    },
    RemoveFund(context, data){
        return financeAPI.delete(`FinanceTemplateObjectOfExpenditure/${data}`);
    },
}